import React, { useState, useEffect} from "react";
import { pricingService } from "../../../services";
import DynamicTable from "../../../components/admin/Table";
import Modal from "../../../components/UI/Modal";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";

const Plans = () => {
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deletePlan, setDeletePlan] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError]=useState(false)
  const columns = ['name', 'price', 'uploads'];

  const fetchData = async () => {
    try {
      setError(false)
      const plans=await pricingService.allPricingPlans()
      setTableData(plans)
    } catch (error) {
      setError(true)
      console.error("Error fetching data:", error);
    }finally{
      setPageLoading(false)
    }
  };

  // Load initial data on component mount.
  useEffect(() => {
    fetchData();
  }, []);


  // Handlers for row deletion and editing.
  const handleDelete = async () => {
    const data = [...tableData];
    try {
        const newData = data.filter((data) => data._id !== deletePlan._id);
    setTableData(newData);
    await pricingService.deletePricingPlan(deletePlan._id)
    setShowModal(false); 
    } catch (error) {
      setTableData(data)
    }
 
  };

  const handleShowModal = (plan) => {
    setShowModal(true);
    setDeletePlan(plan);
  };

  const handleClodeModal = () => {
    setShowModal(false);
  };
  const tableTitle = "All Plans"
  const messageTitle=<p className="text-red-500">Comfirm Delete Plan</p>;
  const message=<p> Are you sure you want to remove this plan:<span className="font-bold text-red-500"> {deletePlan?.name}</span>?. This action cannot be undone!</p>;

if(error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={"Error Fetching Plans"} message={"There is error while trying to fetch the plans. Please check your internet contivities and refresh this page to try again"} />

  return (
    <>
      {pageLoading ? (
      <div className="grid place-items-center min-h-[100vh]">  <Spinner /></div>
      ) : (
        <div className="bg-gray-300 p-4  h-full mix-blend-multiply min-h-[100vh]">
          <h1 className="text-xl capitalize font-bold mb-4">{tableTitle}</h1>
          <Modal
            title={messageTitle}
            message={message}
            isOpen={showModal}
            onClose={handleClodeModal}
            comfirmAction={handleDelete}
          />

          <div className="overflow-x-auto">
            <DynamicTable
              columns={columns}
              data={tableData}
              onDelete={handleShowModal}
              url={"-plan"}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Plans;
